module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c0GZb"))).then(() => parcelRequire('hEqeo'));